import { render, staticRenderFns } from "./InsProvenance.vue?vue&type=template&id=e78348e2&scoped=true"
import script from "./InsProvenance.vue?vue&type=script&lang=js"
export * from "./InsProvenance.vue?vue&type=script&lang=js"
import style0 from "./InsProvenance.vue?vue&type=style&index=0&id=e78348e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78348e2",
  null
  
)

export default component.exports